import React from 'react';
import { Card, Link } from '@tcc/crate';
import { getMessage } from 'util/locale';
import { FIELD_VIEW_URL } from 'constants/urls';

const uploadCardClassName = 'vra-management-zones-quick-view upload';

const ImportedMapsUploadCard = () => {
  return (
    <Card className={uploadCardClassName}>
      <div className="wrapper">
        <div>
          {getMessage('text__imported-maps__upload-description')}
        </div>
        <Link href={FIELD_VIEW_URL.DATA_INBOX}>{getMessage('text__imported-maps__upload-now')}</Link>
      </div>
    </Card>
  );
};

export default ImportedMapsUploadCard;
